import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import Checkbox from '../Checkbox';
import { localStorage } from '../../utils/storage';

const MESSAGE_READ = 'messageRead';

function isDontShowAgainOptionSelected(id) {
  return id && localStorage(id).load() === MESSAGE_READ;
}

function clearMessageStatus(id) {
  return id && localStorage(id).clear();
}

/**
Il componente gestisce una checkbox che mostra il messaggio di 'Non visualizzare più'
e memorizza lo stato sul localStorage.

Per sapere se il messaggio è stato letto, si può usare `DontShowAgain.isDontShowAgainOptionSelected`.
*/
const DontShowAgain = ({ message, className, id }) => {
  const [checked, setChecked] = useState(isDontShowAgainOptionSelected(id));

  const handleClick = useCallback(() => {
    const store = localStorage(id);
    const currentValue = store.load();
    const newValue = currentValue === MESSAGE_READ ? undefined : MESSAGE_READ;
    store.save(newValue);
    setChecked(newValue === MESSAGE_READ);
  }, [id]);

  return (
    <div className={cns('dontshowagain', className)}>
      <Checkbox checked={checked} label={message} onClick={handleClick} />
    </div>
  );
};

DontShowAgain.propTypes = {
  /** Classi css personalizzate da aggiungere al componente */
  className: PropTypes.string,
  /** Messaggio da mostrare nella strina del 'Non visualizzare più' */
  message: PropTypes.string,
  /**
Identificativo del componente per la gestione 'Non visualizzare più'.
Lo stato è salvato nella sessione locale del browser quindi è necessario un identificativo per gestire il salvataggio.

Tipicamente è composto dall'id dell'utente e da un identificativo del messaggio.
*/
  id: PropTypes.string.isRequired,
};

DontShowAgain.defaultProps = {
  className: undefined,
  message: 'Non visualizzare più',
};

DontShowAgain.isDontShowAgainOptionSelected = isDontShowAgainOptionSelected;
DontShowAgain.clearMessageStatus = clearMessageStatus;

export default DontShowAgain;
